import { useTranslation } from 'react-i18next';

import { Label } from '@/components/ui/label';
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';

import { MAP_GROUP_BY_CONFIG } from '../lib/map-grouping.config';
import { MAP_GROUP_BY, type MapGroupBy } from '../model/types';

interface GroupByControlProps {
  groupBy: MapGroupBy;
  onChange: (groupBy: MapGroupBy) => void;
}

export function GroupByControl({ groupBy, onChange }: GroupByControlProps) {
  const { t } = useTranslation();

  return (
    <RadioGroup className="gap-1.5" value={groupBy} onValueChange={(value) => onChange(value as MapGroupBy)}>
      {MAP_GROUP_BY.map((value) => (
        <div key={value} className="flex items-center gap-2">
          <RadioGroupItem id={`map-group-by-${value}`} value={value} />
          <Label htmlFor={`map-group-by-${value}`} className="cursor-pointer text-xs font-normal">
            {t(MAP_GROUP_BY_CONFIG[value].labelKey)}
          </Label>
        </div>
      ))}
    </RadioGroup>
  );
}
